// extracted by mini-css-extract-plugin
export var brand = "_by-9";
export var compact = "_by-6";
export var extraSmall = "_by-7";
export var icon = "_by-0";
export var large = "_by-4";
export var light = "_by-1";
export var medium = "_by-5";
export var outline = "_by-b";
export var primaryDark = "_by-a";
export var primaryLight = "_by-8";
export var primaryModern = "_by-c";
export var success = "_by-2";
export var successSolid = "_by-3";